import { makeStyles } from '@mui/styles';
import { Checkbox } from 'apollo-react';
import Typography from 'apollo-react/components/Typography';
import React from 'react';

const useStyles = makeStyles({
  viewCell: {
    marginTop: 5,
    marginRight: 5,
    width: ({ level, width }) => width - level * 24,
    minWidth: 100,
    '&:hover': {
      cursor: 'pointer',
    },
    display: 'flex',
    alignItems: 'center',
  },
  value: {
    fontSize: 14,
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    wordWrap: 'break-word',
    whiteSpace: 'pre-line',
    minWidth: 100,
  },
});

const TextViewCell = ({ row, column: { accessor: key } }) => {
  const { level, entityNameWidth, selectRow, Id, selectedViewId } = row;

  const classes = useStyles({ level, width: entityNameWidth });

  const value = row[key];

  return (
    <div
      role="none"
      className={classes.viewCell}
      key={key}
      onClick={() => selectRow(Id)}
      onKeyDown={() => selectRow(Id)}
    >
      {selectedViewId === Id && <Checkbox checked={true} />}

      <Typography className={classes.value}>{value}</Typography>
    </div>
  );
};

export default TextViewCell;
